import { Component } from '@angular/core';

@Component({
  selector: 'app-cards10-examples-63',
  templateUrl: './cards10-examples-63.component.html'
})
export class Cards10Examples63Component {}
